import { useNotification, useTimeZone } from '../../../../../hooks'
import {
  getTaskFormEditPayload,
  getTaskFormInitialValues,
  TaskFormModal,
} from '../../../../Task'
import {
  getMockCalendarTask,
  updateMockCalendarTask,
} from '../../../Calendar.mock'
import { CalendarTaskRequestLink } from '../../../CalendarTaskRequestLink'

// TODO: read the task with getTask and write it with updateTask once the feed
// returns real task ids (TM-01-08).
export function useCalendarViewTask({
  getActionToken,
  setModal,
  onClose,
  onReload,
}) {
  const timezone = useTimeZone()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  function handleSaved() {
    onReload()

    handleAddSuccessNotification('Notification.CommonTitleSavedKey')
  }

  function handleFailed() {
    handleAddErrorNotification('Error.CommonApiRequestFailKey')
  }

  async function handleChangeTaskStatus({ changes, task }) {
    return updateMockCalendarTask({
      changes,
      id: task.id,
      sourceDate: task.date,
      timezone,
    })
      .then(handleSaved)
      .catch(handleFailed)
  }

  function handleSuccessTaskEdit() {
    onClose()

    handleSaved()
  }

  function getHandleSubmitTask(task) {
    return async changes =>
      updateMockCalendarTask({
        changes,
        id: task.id,
        sourceDate: task.date,
        timezone,
      })
  }

  async function handleOpenTask(task) {
    const actionToken = getActionToken()

    return getMockCalendarTask({ date: task.date, id: task.id, timezone })
      .then(({ data }) => {
        if (getActionToken() === actionToken) {
          setModal(
            <TaskFormModal
              fieldsProps={{
                ServiceRequestAddon: CalendarTaskRequestLink,
                phases: data.phases,
                serviceRequestAddonProps: { request: task.request },
                submitButtonText: 'Task.FormEditSubmitBtnKey',
              }}
              getPayload={getTaskFormEditPayload}
              initialValues={getTaskFormInitialValues(data.task, timezone)}
              title='Modal.EditTaskTitleKey'
              onClose={onClose}
              onSubmit={getHandleSubmitTask(task)}
              onSuccess={handleSuccessTaskEdit}
            />
          )
        }
      })
      .catch(handleFailed)
  }

  return { handleChangeTaskStatus, handleOpenTask }
}
